<abs-modals-and-alerts-component [(modalAction)]="openModal" (modalClosed)="close($event, 'openModal')"
  windowClass="modal-docked" sizeClass="modal-small">
  <abs-modals-and-alerts-content-component id="customer-utf-modal-popup" class="modal-size">
    <main class="modal-header" tabindex="0">
      <h1 style="display:none;"></h1>
      <h2 id="customer-utf-modal-container">{{cfetLabels.cfet_eligibility_utf_modal.heading}}</h2>
      <div class="corner-button">
        <button type="button" id="close-btn" class="close-modal-button" tabindex="0" [attr.aria-label]="'Close'"
          (click)="close($event, 'openModal')" (keyup)="close($event,'openModal')">
          <em aria-label="Close" id="icon-close" class="icon-close modal-close-icon" role="img"></em>
        </button>
      </div>
    </main>
    <section class="modal-body" id="confirmation-buttons-section" modal-content tabindex="0">
      <div id="modal-desc">
        <p id="description" [innerHTML]="cfetLabels. utf_eligibility_utf_modal.description"></p>
      </div>
      <div class="row no-gutters" id="confirmation-buttons">
        <button type="button" id="btn-utf" (click)="continue($event,'openModal')" (keyup)="continue($event,'openModal')"
          class="btn btn-alt btn-medium" tabindex="0"><em aria-label=""></em>
          {{cfetButtonLabels.button_labels.completeProfile}}</button>
      </div>
    </section>
  </abs-modals-and-alerts-content-component>
</abs-modals-and-alerts-component>